import { createGlobalStyle } from "styled-components";
import "@wordpress/block-library/build-style/style.css";

export const GlobalStyle = createGlobalStyle`
    ${({ theme }) =>
      ["fontLinks", "fontHeadings", "fontParagraphs", "fontButtons"]
        .map(
          (fontType) => `
    @font-face {
      font-family: ${theme[fontType].fontFamily};
      font-style: normal;
      font-weight: normal;
      font-display: swap;
      src: 
        url("${theme[fontType].woff2}") format("woff2"),
        url("${theme[fontType].woff}") format("woff");
    }
  `
        )
        .join("")}
  
:root {
  --color-primary: ${({ theme }) => theme.colors.primary};
  --color-secondary: ${({ theme }) => theme.colors.secondary};
  --color-black: ${({ theme }) => theme.colors.black};
  --color-white: ${({ theme }) => theme.colors.white};
  --color-accent1: ${({ theme }) => theme.colors.accent1};
  --color-accent2: ${({ theme }) => theme.colors.accent2};
  --color-accent3: ${({ theme }) => theme.colors.accent3};
  --color-body: ${({ theme }) => theme.colors.body};
  --color-body-text: ${({ theme }) => theme.colors.bodyText};
  --color-body-link: ${({ theme }) => theme.colors.bodyLink};
  --border-radius: ${({ theme }) => theme.borderRadius};
  --font-paragraphs: ${({ theme }) => theme.fontParagraphs.fontFamily};
  --container-border-radius: ${({ theme }) =>
    theme.containerBlocksBorderRadius};
  --color-light-grey: #ebeced;
  --color-grey: #999;
  --color-facebook-blue: #4267b2;
}

* {
  box-sizing: border-box;
}
  body {
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.typography.fontFamily}, "sans-serif";
    margin: 0;
        background-color: ${({ theme }) => theme.colors.body};
    color: ${({ theme }) => theme.colors.bodyText}
  }
  @media all and (-ms-high-contrast: none),
  (-ms-high-contrast: active) {

  /* IE10+ CSS styles go here */

  }
  .breadcrumbs-wrapper {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .breadcrumbs-wrapper::-webkit-scrollbar {
    display: none;
  }
  .animate-disabled {
    transform: none !important;
    opacity: 1 !important;
    transition-duration: 0s !important;
  }
  section {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    margin: 60px 0;
  }
  ul {
    width: 100%;
  }
  //This is to override the standard blue that Safari iOS sets for <button>-elements
  button {
    color: ${({ theme }) => theme.colors.bodyText};
    font-family: ${({ theme }) => theme.fontButtons.fontFamily}, "sans-serif";
  }
  a {
    color: ${({ theme }) => theme.colors.bodyLink};
    font-family: ${({ theme }) => theme.fontLinks.fontFamily} , "sans-serif";
  }
  .button {
    padding: 13px 25px 11px 25px;
    font-size: 1rem;
    text-decoration: none;
    transition: 0.3s all ease-in-out;
    font-family: ${({ theme }) => theme.fontButtons.fontFamily}, "sans-serif";
    max-width: 300px;
    margin: 5px 10px 5px 0;
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
    border: 1px solid ${({ theme }) => theme.colors.black};
    outline: none;
    &:hover {
      text-decoration: none;
      cursor: pointer;
      color: ${({ theme }) => theme.colors.black};
      border: 1px solid #000;
    }
    &.secondary {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.white};
      &:hover {
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.black};
      }
    }
  }
  p {
    line-height: 1.5;
    font-size: 1rem;
    width: 100%;
    margin-top: 5px;
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
  }
  div {
    line-height: 1.5;
  }
  h1, h2, h3, h4, h5, h6 {
    width: 100%;
    margin: 5px 0;
    font-weight: unset;
    font-family: ${({ theme }) => theme.fontHeadings.fontFamily}, "sans-serif";
  }

 main ul:not(.slider) {
    width: 100%;
    list-style-type: none;
    li {
        &:before {
        content: "\\2022";
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 700;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }
    }
  }
  .margin-bottom {
    margin-bottom: 20px;
  }
  .img-width {
    width: 100%;
  }
  .img-auto-width {
    width: auto;
  }
  .row-container {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1.5rem;
    margin: 30px 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
      margin: 0;
      flex-wrap: wrap;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      justify-content: flex-start;
      flex-direction: column;
    }
  }
  .employee-card-container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    gap: 1rem;
    width: 100%;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
     flex-direction: column;
    }
  }
  .faq-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    border: 2px solid ${({ theme }) => theme.colors.secondary};
    border-radius: 0.2rem;
  }
  .metric-wrapper {
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      justify-content: space-around!important;
    }
  }
  .button-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    margin-block: 0.625rem;
    gap: 0.625rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}){
      margin: 0;
      justify-content: center;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      justify-content: center;
    }
  }
  .button-margin-wide {
    margin: 5px 25px !important;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}){
      margin: 10px;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      margin: 10px;
      width: 44%;
    }
  }
  .door-container {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, max-content));
    padding: initial;
    justify-content: flex-start;
    @media (min-width: 700px){
      grid-template-columns: repeat(auto-fit, minmax(230px, max-content));
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.wide}){
      grid-template-columns: repeat(auto-fit, minmax(238px, max-content));
    }
  }

  .hero__headline {
    font-weight: 300;
    font-size: 40px;
    margin-bottom: 10px;
    text-shadow: 0 1px 6px rgba(0, 0, 0, 0.16);
  }
  .hero__subline {
    text-transform: uppercase;
    font-size: 40px;
    font-weight: 600;
    margin: 0 0 1rem 0;
    text-shadow: 0 1px 6px rgba(0, 0, 0, 0.26);
  }

  .carousel-root,
  .carousel,
  .carousel > .slider-wrapper,
  .carousel > .slider-wrapper > .slider {
    height: 100%;
  }
  
  .contact-container {
    height: 100vh;
    padding: 40px 0;
    justify-content: center;
    align-items: flex-start;
    margin: 0;
    width: 100%;
  }
  .contactForm {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    justify-content: center;
    text-align: left;
    max-width:  640px;
    margin-top: -22px;
    padding: 0 20px;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      justify-content: center;
      flex-flow: column wrap;
      max-width: 100%;
    }
    > div {
      width: 100%;
    }
    form {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      p {
        margin-bottom: 5px;
      }
    }
    label {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin: 5px 0;
      font-weight: bold;
    }
    .wpcf7-list-item label {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .half-wrapper {
      display: flex;
      width: 100%;
      max-width: 640px;
      align-items: flex-start;
      gap: 1rem;
      margin-bottom: 10px;
      @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
        max-width: 100%;
      }
    }
    .form-message {
      color: red;
    }
    p span {
      width: 100%;
    }
    input[type=text],
    input[type=tel],
    input[type=email],
    input[type=date],
    textarea {
      width: 100%;
      margin: 5px 0;
      appearance: none;
      border: solid 1px rgba(142, 142, 142, 1);
      background-color: ${({ theme }) => theme.colors.white};
      padding: 15px;
      max-width: 640px;
      font-family: ${({ theme }) => theme.typography.fontFamily};
      @media (max-width: 1024px) {
        max-width: 100%;
      }
    }
    input[type=text]::placeholder,
    input[type=tel]::placeholder,
    input[type=email]::placeholder,
    textarea::placeholder {
      color: #000;
    }

    select {
      width: 100%;
      padding: 15px;
      max-width: 640px;
      margin: 5px 0;
      border: 1px solid var(--color-primary);
      background-color: var(--color-white);
      color: var(--color-black);
      appearance: none;
      background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
      background-repeat: no-repeat;
      background-position: right .7em top 50%;
      background-size: .65em auto;
    }
   
    .wpcf7-form-control-wrap {
      width: 100%;
      margin-bottom: 10px;
    }
    .wpcf7-radio > span,
    .wpcf7-checkbox > span  {
      display: block;
      cursor: pointer;
      margin: 5px 0;
    }
    input[type=radio] {
      appearance: radio;
      margin-left: 0;
      margin-right: 10px;
    }
    input[type=checkbox] {
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
    input[type=submit] {
      background-color: ${({ theme }) => theme.colors.black};
      color: ${({ theme }) => theme.colors.white};
      padding: 12px 36px;
      border-radius: 12px;
      font-size: 1rem;
      border: none;
      transition: 0.3s all ease-in-out;
      font-family:${({ theme }) => theme.fontLinks.fontFamily};
      display: flex;
      justify-content: center;
      align-self: flex-start;
      appearance: none;
      &:disabled {
        opacity: 0.5;
        background-color: #9c9c9c;
      }
      &:disabled:hover {
        cursor: not-allowed;
      }
      &:hover {
        text-decoration: none;
        cursor: pointer;
        filter: brightness(70%);
      }
      @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
        margin-left: 0;
        width: 100%;
        appearance: none;
      }
    }
    input[type=select] {
      appearance: none;
    }
    textarea {
      height: 150px;
      resize: none;
    }
    .checkbox-text {
      font-size: 10px;
      margin-left: 0.5rem;
    }
    .form-input-required-message {
      margin-top: 0;
      color: red;
      font-size: 0.8rem;
    }
  }

  .photo-list {
  width: 90%;
  list-style: none;
  margin: 5px auto;
}

.photo-item {
  display: flex;
  width: 300px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.12);
  margin: 5px 0;
}

.photo-item img {
  display: flex;
  width: 100%;
  cursor: pointer;
  object-fit: contain !important;
}

.fullscreen {
  position: fixed !important;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.9);
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;
} 
  .fullscreen img {
  cursor: zoom-out;
  margin: auto !important;
  width: auto !important;
  height: 100% !important;
  max-width: 1920px !important;
}

  .active-product-link {
    border-bottom: 3px solid ${({ theme }) => theme.colors.primary};
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      border: 1px solid ${({ theme }) => theme.colors.white};
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
    }
  }
  .center {
    text-align: center;
    justify-content: center;
  }
  .wp-block-media-text {
    margin-bottom: 40px;
  }
  .wp-block-media-text:last-child {
    margin-bottom: 0;
  }

  .wp-block-media-text.is-stacked-on-mobile .wp-block-media-text__content {
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
      padding: 0;
    }
  }

  .cf7-disabled {
    background-color: grey !important;
    cursor: wait !important;
  }

  .CookieConsent {
    align-items: baseline;
    background: rgb(53, 53, 53) none repeat scroll 0% 0%;
    color: white;
    display: flex;
    flex-wrap: wrap;
    line-height: 1.4;
    justify-content: space-between;
    font-family: ${({ theme }) =>
      theme.fontParagraphs.fontFamily}, "sans-serif";
    left: 0;
    position: fixed;
    width: 100%;
    z-index: 999;
    bottom: 0;
    padding: 10px;
    @media (max-width: ${({ theme }) => theme.breakpoints.phone}){
      & div {
        display: flex;
      }
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    & button {
      border-radius: var(--border-radius);
      &:nth-child(2) {
        @media (hover: hover) {
          &:hover {
            background-color: transparent;
            border-color: #fefefe;
            color: #fefefe;
          }
        }
      }
    }
  }
  .cover {
    height: 100%;
  }

  .react-reveal {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  
  ${({ theme }) => theme.customCSS}
`;
